import { toast } from 'react-toastify';
import { CHANGE_PASSWORD } from "../action/constant";

const initialState = {
  loading:false,
  err:{},
}

export default function confirmPassReducer(state=initialState,action){
  switch (action.type) {
    case CHANGE_PASSWORD.PENDING:
    return {
      ...state,
      loading:true,
      err:{},
    }
    case CHANGE_PASSWORD.SUCCESS:
      toast.success('Password Updated');
      return {
        ...state,
        loading:false,
        err:{},
      }
    case CHANGE_PASSWORD.ERROR:
      toast.error(action.err.error);
      return {
        ...state,
        loading:false,
        err:action.err,
      }
    default:
     return state;
  }
}
